
import { computed } from 'vue'

import { RepositoryTimeline } from '@types'

import useAnalyticsStore from '@/store/analytics'
import { useRepositoriesStore } from '@/store/repositories/index'

export const useTimeline = () => {

  const analyticsStore = useAnalyticsStore()
  const repositoriesStore = useRepositoriesStore()

  const timeline = computed(() => repositoriesStore.getCurrentTimeline)
  const dates = computed(() => analyticsStore.getDatesRangeWithZeroDate)

  const sliderDate = computed(() => analyticsStore.getDate)

  const loading = computed(() => analyticsStore.isLoading || analyticsStore.hasPendingUpdates)

  const handleUpdateTimeline = async (
    timeline: RepositoryTimeline,
    isEndChanged = false,
  ) => {
    analyticsStore.cancel()
    analyticsStore.refresh(isEndChanged ? undefined : ['tree'])

    await repositoriesStore.setCurrentTimeline(timeline, isEndChanged)
    analyticsStore.markAsDeprecated(isEndChanged ? [] : ['tree', 'irr_moic'])
  }

  const handleUpdateSliderDate = (value: string) => {
    analyticsStore.setDate(value)
  }

  return {
    timeline,
    dates,
    sliderDate,
    loading,
    handleUpdateTimeline,
    handleUpdateSliderDate,
  }
}
